import { BaseConnector } from './baseConnector';

class FieldTemplateConnector extends BaseConnector {
  getFieldTemplates(hearingTypeId) {
    var url = `${this.baseApiUrl}/hearingType/${hearingTypeId}/fieldTemplate`;
    return this.authFetch(url);
  }

  createFieldTemplate(hearingTypeId, fieldTemplate) {
    var url = `${this.baseApiUrl}/hearingType/${hearingTypeId}/fieldTemplate`;
    return this.authPost(url, fieldTemplate);
  }

  updateFieldTemplate(hearingTypeId, fieldTemplateId, fieldTemplate) {
    var url = `${this.baseApiUrl}/hearingType/${hearingTypeId}/fieldTemplate/${fieldTemplateId}`;
    return this.authPatch(url, fieldTemplate);
  }

  deleteFieldTemplate(hearingTypeId, fieldTemplateId) {
    var url = `${this.baseApiUrl}/hearingType/${hearingTypeId}/fieldTemplate/${fieldTemplateId}`;
    return this.authDelete(url);
  }
}

export { FieldTemplateConnector };
